import angular from 'angular';

import TimeComponent from './time.cmpt';

export default angular
    .module('application.component.time', [])
    .component(TimeComponent.selector, TimeComponent);



// WEBPACK FOOTER //
// ./src/application/component/time/index.js